











































































































































































































import {
  Vue,
  Component,
  Emit,
  PropSync,
  Prop,
  Watch
} from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
// import InsufficientCreditDialog from '@/modules/payment/components/InsufficientCreditDialog'
import tournamentStore from '@/modules/tournament/tournament.store'
import { TournamentAPI, TournamentGroupAvailability } from '@/api/tournament'
import ServerError from '@/utils/server_error'
// import paymentStore from '@/modules/payment/payment.store'

@Component({
  components: {
    // InsufficientCreditDialog
  }
})
export default class TournamentRegistration extends Vue {
  @PropSync('action', { default: null })
  tournamentAction!: 'create' | 'join' | null

  @Prop({ required: true })
  seed!: number

  tournamentModule = getModule(tournamentStore, this.$store)
  // paymentModule = getModule(paymentStore, this.$store)

  // isCheckingBalance: boolean = false
  // isInsufficientCreditDialogVisible: boolean = false

  isSelectingGroup: boolean = false
  selectedGroup: string | null = null

  isGroupsLoading: boolean = false
  groups: TournamentGroupAvailability[] = []

  @Watch('seed')
  async onSeedChanged() {
    this.isSelectingGroup = this.tournament!.hasGroup
    this.selectedGroup = null

    if (this.isSelectingGroup) {
      await this.fetchGroups()
    }
  }

  async mounted() {
    await this.onSeedChanged()
  }

  /* Emitters */
  @Emit('back')
  onBack() {
    return this
  }

  /* Methods */
  async onNext() {
    // Check balance if tournament contains per team registration fee
    /* if (this.perTeamRegistrationFee !== 0) {
      this.isCheckingBalance = true
      await this.paymentModule.getWallet()
      this.$nextTick(() => {
        this.isCheckingBalance = false
        if (!this.wallet || this.wallet.subtotal < this.perTeamRegistrationFee)
          this.isInsufficientCreditDialogVisible = true
        else this.$emit('next')
      })
    } else { */
    this.$emit('next', this.selectedGroup)
    // }
  }

  async fetchGroups() {
    this.isGroupsLoading = true

    try {
      const res = await TournamentAPI.getTournamentGroups(
        this.tournament!.tournamentId
      )
      this.groups = res.data.payload!
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('Landing.SystemErrorMessage'))
      }
    } finally {
      this.isGroupsLoading = false
    }
  }

  /* Computed Properties */
  get tournament() {
    return this.tournamentModule.selectedTournament
  }

  get perTeamRegistrationFee() {
    return 0
    // if (!this.tournament) return 0
    // return this.tournament.paymentPerTeamRegistrationFee
  }
  /*

  get wallet() {
    return this.paymentModule.wallet
  } */

  get canSelectGroup() {
    if (!this.selectedGroup) {
      return false
    }

    const group = this.groups.find(group => group.name === this.selectedGroup)
    if (!group) return false
    return group.available
  }

  get isSelectedGroupNotAvailable() {
    const group = this.groups.find(group => group.name === this.selectedGroup)
    if (!group) return false
    return !group.available
  }
}
